import { OnInit, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { BillingInvoiceEntityService } from 'src/app/services/billing/billing-invoice/billing-invoice-entity.service';
import { BillingInvoiceLogItem } from 'src/app/model/billing/billing-invoice-log-item';


@Component({
  selector: 'app-billing-invoice-log-dialog',
  templateUrl: 'billing-invoice-log-dialog.component.html',
  styleUrls: ['./billing-invoice-log-dialog.component.css']
})

export class BillingInvoiceLogDialogComponent implements OnInit {

  logs: BillingInvoiceLogItem[] = [];

  loading: boolean = false;

  constructor(private billingInvoiceEntityService: BillingInvoiceEntityService
    , private notificationToastService: NotificationToastService
    , public dialogRef: MatDialogRef<BillingInvoiceLogDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public invoiceId: number) {
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  async ngOnInit() {
    await this.getObservations();
  }

  private async getObservations() {
    try {
      this.loading = true;
      this.logs = await this.billingInvoiceEntityService.getBillingInvoiceLog(this.invoiceId);
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Logs del turno');
    } finally {
      this.loading = false;
    }
  }
}
